import apiClient from './client';

export interface Estimate {
  id: number;
  title: string;
  client_id: number;
  job_id: number;
  job_title?: string;
  total_amount: number;
  status: string;
  created_at: string;
  quote_id?: number | null;
  quote_number?: string | null;
}

export interface LabourEstimate {
  id: number;
  title: string;
  client_id: number;
  job_id: number;
  job_title?: string;
  job_number?: string;
  client_name?: string;
  total_hours: number;
  hourly_rate: number;
  total_amount: number;
  status: string;
  notes?: string;
  created_at: string;
  updated_at?: string;
  quote_id?: number | null;
  quote_number?: string | null;
}

export const getEstimatesByJob = async (jobId: string | number): Promise<Estimate[]> => {
  const response = await apiClient.get('/estimates', { params: { job_id: jobId } });
  return response.data.data;
};

export const getLabourEstimatesByJob = async (jobId: string | number): Promise<LabourEstimate[]> => {
  const response = await apiClient.get('/labour-estimates', { params: { job_id: jobId } });
  return response.data.data;
};
